<template>
    <div>
        <home-skeleton v-if="!skeleton" style="margin-top: 30px"></home-skeleton>
        <div class="preview-pdf" v-else>
            <div :class="[loading ? 'content-imnage' : '']" v-for="item in imageList" :key="item.id">
                <img width="100%" @load="onImgeLoad(true)" :src="item.replace('https:/g', 'https://g')" alt="" />
            </div>
        </div>
    </div>
</template>
<script>
import Interface from '@/util/interface'
import homeSkeleton from '@/skeleton/homeSkeleton'
export default {
    components: {
        homeSkeleton
    },
    computed: {
        imageList() {
            const imgs = this.pdf && this.pdf.pdf_images
            return typeof imgs === 'string' && imgs.length > 0 ? imgs.split(',') : []
        }
    },
    data() {
        return {
            loading: false,
            pdf: {
                pdf_images: ''
            },
            skeleton: false
        }
    },
    methods: {
        onImgeLoad(row) {
            this.loading = row
        },
        getPdfUrl() {
            Interface.getData('get', `${Interface.anticancer.manualList}/${this.$route.params.id}`).then(res => {
                this.pdf = res.data
                Interface.getShareInfo(this, this.pdf.title, this.pdf.cover_img)
                this.skeleton = true
            })
        }
    },
    mounted() {
        this.getPdfUrl()
    }
}
</script>
<style lang="scss">
.preview-pdf {
    h1 {
        margin: 30px auto;
        text-align: center;
        font-family: '宋体';
        letter-spacing: 2px;
    }
    img {
        margin-top: -3px;
    }

    .content-imnage {
        position: relative;
        &::before {
            content: '';
            position: absolute;
            left: 30%;
            top: 30%;
            width: 150px;
            height: 150px;
            background: url('/static/bytx/watermark_logo@3x.png') no-repeat;
            background-size: cover;
        }
    }
}
</style>



// WEBPACK FOOTER //
// src/views/anticancer/manual/details/index.vue